import { useAuthContext } from './contexts/AuthContext.tsx'
import { useUserContext } from './contexts/UserContext.tsx'
import { isDevEnv } from '../tools/env.ts'
import Router from './Router.tsx'
import FullScreenLoading from './common/FullScreenLoading.tsx'
import { logPropertyValues } from '../tools/dom/css-properties.ts'

if (isDevEnv()) {
    // Output css variables for debugging purposes.
    const properties: string[] = [
        // '--surface-ground',
        // '--surface-section',
        // '--surface-card',
        // '--surface-overlay',
        // '--surface-border',
        // '--surface-hover',
    ]
    setTimeout(() => logPropertyValues(properties), 1000)
}

export default function App() {
    const { isLoading: isAuthLoading } = useAuthContext()
    const { loading: isUserLoading } = useUserContext()
    const isLoading = isAuthLoading || isUserLoading
    return isLoading ? <FullScreenLoading /> : <Router />
}
